<template>
  <div class="schedule-label-component">
    <div class="schedule-status">
      <vd-custom-icon name="calendar-icon" class="calendar-icon" width="12" :color="`var(--${scheduleInfo.color})`" />
      <span :style="{ color: `var(--${scheduleInfo.color})` }">&nbsp;{{ scheduleInfo.label }}</span>
    </div>
    <div class="schedule-dates">
      <span>Starts: {{ startsAt }}</span>
      <span>Finish: {{ endsAt }}</span>
    </div>
  </div>
</template>

<script lang="ts">
import { parseISO } from "date-fns";
import { computed, defineComponent, PropType } from "vue";

import { ConfigurationRuleSchedule } from "@/graphql";

function formatUtcDate(dateString: string): string {
  const iso = new Date(dateString).toISOString();
  return `${iso.substring(0, 10)} ${iso.substring(11, 16)} (UTC)`;
}

export default defineComponent({
  name: "ScheduleLabel",

  props: {
    schedule: {
      type: Object as PropType<ConfigurationRuleSchedule | null>,
      default: () => null,
    },

    alignRight: {
      type: Boolean,
      default: false,
    },
  },

  setup(props) {
    const scheduleInfo = computed(() => {
      if (!props.schedule?.ranges || props.schedule.ranges.length === 0) {
        return { color: "red-ion", label: "Schedule Error" };
      }

      const now = Date.now();
      const beginsAt = parseISO(props.schedule.ranges[0].beginsAt).getTime();
      const endsAt = parseISO(props.schedule.ranges[0].endsAt).getTime();

      if (now >= endsAt) {
        return { color: "red-alert", label: "Outdated" };
      }

      if (beginsAt <= now && now < endsAt) {
        return { color: "green-alert", label: "Running" };
      }

      return { color: "slate", label: "Pending" };
    });

    const startsAt = computed(() => {
      if (!props.schedule?.ranges || props.schedule.ranges.length === 0) {
        return "N/A";
      }
      return formatUtcDate(props.schedule.ranges[0].beginsAt);
    });

    const endsAt = computed(() => {
      if (!props.schedule?.ranges || props.schedule.ranges.length === 0) {
        return "N/A";
      }
      return formatUtcDate(props.schedule.ranges[0].endsAt);
    });

    return {
      scheduleInfo,
      startsAt,
      endsAt,
    };
  },
});
</script>

<style lang="scss" scoped>
.schedule-label-component {
  font-size: font("XS");
  color: $slate;
  line-height: font("M");

  .schedule-status {
    display: flex;
    align-items: center;
  }

  .schedule-dates {
    display: flex;
    flex-direction: column;
    font-family: monospace;
  }
}
</style>
